const BaseModel = require('./BaseModel');

class FlowNudge extends BaseModel {
  static basePath = '/api/v1/flows/:flowId/nudges';
  static dataType = 'flow-nudge';

  constructor(json={}) {
    super(json);

    this.parseChildren(['flow', 'template']);
  }

  static basePathFor(flowId) {
    return(this.basePath.replace(':flowId', flowId));
  }

  static pathFor(nudge) {
    const flowId = nudge?.flowId;
    if(!flowId) { throw new Error('item has no flow id') }

    return(`${this.basePathFor(flowId)}`);
  }

  static list(flowOrId, args = {}) {
    let flowId;
    if(!flowOrId) { throw new Error('flow or id must be provided') }
    if(typeof(flowOrId) == 'string') { flowId = flowOrId }
    else if(flowOrId.hasOwnProperty('id')) { flowId = flowOrId.id }
    else { throw new Error('cannot understand flow or id provided') }
    return(BaseModel.list({ ...args, path: this.basePathFor(flowId) }));
  }

  static create(item, args = {}) {
    const flowId = item.flowId;
    if(!flowId) { throw new Error('item has no flow id') }
    return(BaseModel.create(item, { ...args, path: this.basePathFor(flowId) }));
  }

  static update(item, args = {}) {
    return(BaseModel.update(item, { ...args, path: this.pathFor(item) }));
  }

  static delete(item, args = {}) {
    return(BaseModel.delete(item, { ...args, path: this.pathFor(item) }));
  }
}

BaseModel.models[FlowNudge.dataType] = FlowNudge;
module.exports = FlowNudge;
